/** @format */

import {getDaysInMonth, getDaysInYear} from 'date-fns';

import {HALF_YEAR_DAYS, QUARTER_DAYS, WEEK_DAYS} from '../const';
import {Period} from '../model';

/**
 * Вернёт количество дней в периоде.
 * Если период текущий, то логика для него такая же, как для месяца.
 * Если период кастомный, то вернёт период из одного дня.
 * @param period
 * @param currentDate
 */

const getPeriodDays = (period: Period, currentDate: Date): number => {
  switch (period) {
    case 'current':
    case 'month': {
      return getDaysInMonth(currentDate);
    }
    case 'half-year': {
      return HALF_YEAR_DAYS;
    }
    case 'quarter': {
      return QUARTER_DAYS;
    }
    case 'year': {
      return getDaysInYear(currentDate);
    }
    case 'week': {
      return WEEK_DAYS;
    }
    default:
      return 1;
  }
};

export default getPeriodDays;
